/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiConfig: {
    baseUrl: 'https://api.widy.justbit.it',
    version: 'v1',
  },
  firebase: {
    apiKey: "AIzaSyBCj0JLSD_35AZTw6elKNdLWgPcn0jVufk",
    authDomain: "acea-waidy.firebaseapp.com",
    databaseURL: "https://acea-waidy.firebaseio.com",
    projectId: "acea-waidy",
    storageBucket: "acea-waidy.appspot.com",
    messagingSenderId: "102321652808",
    appId: "1:102321652808:web:24140cf35086dd5924447d",
    measurementId: "G-9W1KL1N1T3",
    storage: {
      storeImagesRef: '/Store',
      eventImagesRef: '/Event'
    }
  }
  
};
